/**
 * Session practice tracker — port of iOS
 * `client-native/src/features/lesson/state/sessionPracticeTracker.ts`.
 *
 * Counts how many times each word has been drilled this app session so the
 * scorer can deprioritize over-practiced words (more variety). In-memory only;
 * cleared on logout / app restart.
 */
const practiceCounts = new Map<string, number>();

export const sessionPracticeTracker = {
  /** Record that words were used in activities. */
  recordPracticed(wordKeys: string[]): void {
    for (const key of wordKeys) {
      practiceCounts.set(key, (practiceCounts.get(key) ?? 0) + 1);
    }
  },

  /** How many times a word has been practiced this session. */
  getPracticeCount(wordKey: string): number {
    return practiceCounts.get(wordKey) ?? 0;
  },

  /** Clear all tracking (e.g. on logout). */
  clearAll(): void {
    practiceCounts.clear();
  },
};
